import { ISchedule } from '@cbridge-packages/schedule';
import { Dayjs } from 'dayjs';

export interface IScheduleInterval {
  intervalId: string;
  startDayOfWeek: number;
  startTime: number;
  endDayOfWeek: number;
  endTime: number;
  type: ScheduleIntervalType;
}

export enum ScheduleIntervalType {
  Pricing = 'pricing',
  Trading = 'trading',
  Both = 'both',
}

export interface IScheduleIntervalForm {
  intervalId?: string;
  startDayOfWeek?: number;
  startTime?: Dayjs;
  endDayOfWeek?: number;
  endTime?: Dayjs;
  type?: ScheduleIntervalType;
}

export interface IScheduleIntervalStore {
  data: Record<ISchedule['scheduleId'], IScheduleInterval[]>;
  loading: Record<ISchedule['scheduleId'], boolean>;
}

export interface IScheduleIntervalStoreSegment {
  scheduleInterval: IScheduleIntervalStore;
}
